<template>
  <div class="mt-4">
    <b-row class="mb-3" v-for="(item, index) in list" :key="index">
      <b-col sm="2">
        <label class="font-weight-bold main-label"
          >Variation #{{ index + 1 }}</label
        >
        <div
          v-if="
            item.option[0].label.length == 0 ||
            (!v.$each.$iter[index].label && v.$each.$iter[index].label.$error)
          "
        >
          <span class="text-error"
            >Please enter option at least 1 option.
          </span>
        </div>
      </b-col>
      <b-col sm="10">
        <div class="ops-box py-3 px-4 position-relative">
          <div class="text-right delete-ops-icon">
            <font-awesome-icon
              @click="onDeleteVariation(index)"
              icon="times-circle"
              class="text-secondary delete-icon pointer"
            />
          </div>

          <b-form-group
            id="fieldset-horizontal"
            label-cols-sm="3"
            :label="'Option Name'"
            label-for="ops-name"
            label-align-sm="right"
          >
            <b-form-input
              @keyup="onVariationKeyUp(index)"
              id="ops-name"
              class="input-ops"
              v-model="item.label"
            ></b-form-input>
            <div
              v-if="
                v.$each.$iter[index].label && v.$each.$iter[index].label.$error
              "
            >
              <span
                class="text-error"
                v-if="v.$each.$iter[index].label.required == false"
                >required
              </span>
            </div>
          </b-form-group>

          <div v-for="(item2, index2) in item.option" :key="index2">
            <b-form-group
              id="fieldset-horizontal"
              label-cols-sm="3"
              :label="'options' + ' ' + (index2 + 1)"
              label-for="ops-1"
              label-align-sm="right"
            >
              <div class="d-flex">
                <b-form-input
                  id="ops-1"
                  @keyup="onOptionKeyUp(index, index2)"
                  class="input-ops"
                  v-model="item2.label"
                ></b-form-input>
                <div class="pl-2 pt-2">
                  <font-awesome-icon
                    @click="onDeleteOption(index, index2)"
                    icon="trash-alt"
                    class="text-danger delete-icon pointer"
                    v-if="index2 !== 0"
                  />
                </div>
              </div>
              <div
                v-if="
                  v.$each.$iter[index].option.$each.$iter[index2].label &&
                  v.$each.$iter[index].option.$each.$iter[index2].label.$error
                "
              >
                <span
                  class="text-error"
                  v-if="
                    v.$each.$iter[index].option.$each.$iter[index2].label
                      .required == false
                  "
                  >required
                </span>
              </div>
            </b-form-group>
          </div>

          <div
            class="create-ops-box m-auto pointer"
            @click="createOptionsChoice(index)"
          >
            + Create new option
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="list && list.length < 3">
      <b-col sm="2">
        <label class="font-weight-bold main-label"
          >options <span class="text-danger">*</span></label
        >
      </b-col>
      <b-col sm="10">
        <div class="create-ops-box pointer" @click="createOptions">
          + Create new option
        </div>
      </b-col>
    </b-row>
    <div v-if="v && v.$error">
      <span class="text-error" v-if="v.required == false">
        Please enter at least 1 option.
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfigOptionsSection",
  props: {
    dataList: {
      required: false,
      type: Array,
    },
    childrenObject: {
      required: false,
      type: Object,
    },
    isEdit: {
      required: false,
      type: Boolean,
    },
    productAttributeImage: {
      required: false,
      type: Array,
    },
    v: {
      required: false,
      type: Object,
    },
    translationList: {
      type: Array,
    },
    advancePrice: {
      type: Object,
    },
    sku: {
      type: String,
    },
  },
  data() {
    return {
      displayOption: [],
      editFlag: this.isEdit,
      imageList: this.productAttributeImage,
      attributeOptionTemp: [],
      firstLevel: "",
    };
  },
  computed: {
    list: {
      get: function () {
        return this.dataList;
      },
    },
    // children: {
    //   get: function() {
    //     return this.childrenObject;
    //   },
    //   set: function() {}
    // }
  },
  watch: {
    translationList: {
      deep: true,
      handler: function () {
        if (this.list.length > 0 && this.isEdit) {
          this.children = this.childrenObject;
          this.onChangeProductName();
        }
      },
    },
    sku: {
      deep: true,
      handler() {
        if (this.list.length > 0 && this.isEdit) {
          this.children = this.childrenObject;
          this.onChangeProductSKU();
        }
      },
    },
    advancePrice: {
      deep: true,
      handler() {
        if (this.list.length > 0) {
          this.children = this.childrenObject;
          this.onChangeProductAdvancePriceDate();
        }
      },
    },
  },
  mounted() {},
  methods: {
    onDeleteVariation(index) {
      this.list.splice(index, 1);
      if (this.list.length == 0) {
        this.children.attributeOption = [];
      } else if (this.list.length == 1) {
        this.clearChildren();
      } else if (this.list.length == 2) {
        this.children = {
          id: 0,
          code: this.list[0].code,
          label: this.list[0].label,
          sortOrder: 0,
          attributeOption: [],
        };
        this.$emit("setProductChildren", this.children);
        this.createChildrenLv2AfterDelete();
      }
    },
    onChangeProductAdvancePriceDate() {
      this.list[0].option.forEach((option1, index1) => {
        if (this.list.length > 1) {
          this.list[1].option.forEach((option2, index2) => {
            if (this.list.length > 2) {
              this.list[2].option.forEach((option3, index3) => {
                this.children.attributeOption[index1].attribute.attributeOption[
                  index2
                ].attribute.attributeOption[
                  index3
                ].product.advancePrice.startDate = this.advancePrice.startDate;
                this.children.attributeOption[index1].attribute.attributeOption[
                  index2
                ].attribute.attributeOption[
                  index3
                ].product.advancePrice.endDate = this.advancePrice.endDate;
              });
            } else {
              this.children.attributeOption[index1].attribute.attributeOption[
                index2
              ].product.advancePrice.startDate = this.advancePrice.startDate;
              this.children.attributeOption[index1].attribute.attributeOption[
                index2
              ].product.advancePrice.endDate = this.advancePrice.endDate;
            }
          });
        } else {
          this.children.attributeOption[index1].product.advancePrice.startDate =
            this.advancePrice.startDate;
          this.children.attributeOption[index1].product.advancePrice.endDate =
            this.advancePrice.endDate;
        }
      });
    },
    onChangeProductSKU() {
      this.list[0].option.forEach((option1, index1) => {
        if (this.list.length > 1) {
          this.list[1].option.forEach((option2, index2) => {
            if (this.list.length > 2) {
              this.list[2].option.forEach((option3, index3) => {
                this.children.attributeOption[index1].attribute.attributeOption[
                  index2
                ].attribute.attributeOption[
                  index3
                ].product.sku = `${this.sku}-${option1.label}-${option2.label}-${option3.label}`;
                this.children.attributeOption[index1].attribute.attributeOption[
                  index2
                ].attribute.attributeOption[
                  index3
                ].product.barcode = `${this.sku}-${option1.label}-${option2.label}-${option3.label}-barcode`;
              });
            } else {
              this.children.attributeOption[index1].attribute.attributeOption[
                index2
              ].product.sku = `${this.sku}-${option1.label}-${option2.label}`;
              this.children.attributeOption[index1].attribute.attributeOption[
                index2
              ].product.barcode = `${this.sku}-${option1.label}-${option2.label}-barcode`;
            }
          });
        } else {
          this.children.attributeOption[
            index1
          ].product.sku = `${this.sku}-${option1.label}`;
          this.children.attributeOption[
            index1
          ].product.barcode = `${this.sku}-${option1.label}-barcode`;
        }
      });
    },
    onChangeProductName: async function () {
      this.list[0].option.forEach((option1, index1) => {
        if (this.list.length > 1) {
          this.list[1].option.forEach((option2, index2) => {
            if (this.list.length > 2) {
              this.list[2].option.forEach((option3, index3) => {
                this.children.attributeOption[index1].attribute.attributeOption[
                  index2
                ].attribute.attributeOption[
                  index3
                ].product.translationList[0].name = `${this.translationList[0].name}, ${option1.label}, ${option2.label}, ${option3}`;
                this.children.attributeOption[index1].attribute.attributeOption[
                  index2
                ].attribute.attributeOption[
                  index3
                ].product.translationList[0].name = `${this.translationList[0].name}, ${option1.label}, ${option2.label}, ${option3}`;
              });
            } else {
              this.children.attributeOption[index1].attribute.attributeOption[
                index2
              ].product.translationList[0].name = `${this.translationList[0].name}, ${option1.label}, ${option2.label}`;
              this.children.attributeOption[index1].attribute.attributeOption[
                index2
              ].product.translationList[0].name = `${this.translationList[0].name}, ${option1.label}, ${option2.label}`;
            }
          });
        } else {
          if (
            this.children.attributeOption[index1].product.translationList
              .length == 0
          ) {
            this.children.attributeOption[index1].product.translationList = [
              { languageId: 1, name: "" },
              { languageId: 2, name: "" },
            ];
          }
          this.children.attributeOption[
            index1
          ].product.translationList[0].name = `${this.translationList[0].name}, ${option1.label}`;
          this.children.attributeOption[
            index1
          ].product.translationList[1].name = `${this.translationList[0].name}, ${option1.label}`;
        }
      });
    },
    onDeleteOption(index1, index2) {
      let code = this.list[index1].option[index2].code;
      this.list[index1].option.splice(index2, 1);
      if (index1 == 0) {
        let target = this.children.attributeOption.findIndex(
          (attribute) => attribute.code == code
        );
        if (target > -1) {
          this.children.attributeOption.splice(target, 1);
        }
      } else if (index1 == 1) {
        this.children.attributeOption.forEach((attribute1) => {
          let target = attribute1.attribute.attributeOption.findIndex(
            (attribute2) => attribute2.code == code
          );
          if (target > -1) {
            attribute1.attribute.attributeOption.splice(target, 1);
          }
        });
      } else if (index1 == 2) {
        this.children.attributeOption.forEach((attribute1) => {
          attribute1.attribute.attributeOption.forEach((attribute2) => {
            let target = attribute2.attribute.attributeOption.findIndex(
              (attribute3) => attribute3.code == code
            );
            if (target > -1) {
              attribute2.attribute.attributeOption.splice(target, 1);
            }
          });
        });
      }

      this.$emit("setEditFlag", true);
    },
    onOptionKeyUp: async function (index1, index2) {
      let code = this.list[index1].option[index2].code;
      let label = this.list[index1].option[index2].label;
      this.list[index1].option[index2].code = label;
      await this.editChildren(index1, code, label, index2);
    },
    onVariationKeyUp(index) {
      if (index == 0) {
        this.list[0].code = this.list[0].label;
        this.children.code = this.list[0].label;
        this.children.label = this.list[0].label;
      } else if (index == 1) {
        this.list[0].code = this.list[0].label;
        this.list[1].code = this.list[1].label;
        this.children.code = this.list[0].label;
        this.children.label = this.list[0].label;
        this.children.attributeOption.forEach((attribute1) => {
          attribute1.attribute.code = this.list[1].label;
          attribute1.attribute.label = this.list[1].label;
        });
      } else {
        this.list[0].code = this.list[0].label;
        this.list[1].code = this.list[1].label;
        this.list[2].code = this.list[2].label;
        this.children.code = this.list[0].label;
        this.children.label = this.list[0].label;
        this.children.attributeOption.forEach((attribute1) => {
          attribute1.attribute.attributeOption.forEach((attribute2) => {
            attribute2.attribute.code = this.list[2].label;
            attribute2.attribute.label = this.list[2].label;
          });
        });
      }
      this.$emit("setEditFlag", true);
    },
    editChildren(index, code, label, index2) {
      if (this.list.length == 1) {
        this.onSetProduct(
          this.children.attributeOption[index2],
          label,
          `${this.translationList[0].name}, ${label}`,
          `${this.sku}-${label}`,
          `${this.sku}-${label}-barcode`,
          true
        );
      } else if (this.list.length == 2) {
        if (index == 0) {
          this.children.attributeOption[index2].code = label;
          this.children.attributeOption[index2].label = label;
          this.children.attributeOption[
            index2
          ].attribute.attributeOption.forEach((attribute2) => {
            this.onSetProduct(
              attribute2,
              label,
              `${this.translationList[0].name}, ${this.children.attributeOption[index2].label}, ${attribute2.label}`,
              `${this.sku}-${this.children.attributeOption[index2].label}-${attribute2.label}`,
              `${this.sku}-${this.children.attributeOption[index2].label}-${attribute2.label}-barcode`,
              false
            );
          });
        } else if (index == 1) {
          this.children.attributeOption.forEach((attribute1) => {
            this.onSetProduct(
              attribute1.attribute.attributeOption[index2],
              label,
              `${this.translationList[0].name}, ${attribute1.label}, ${label}`,
              `${this.sku}-${attribute1.label}-${label}`,
              `${this.sku}-${attribute1.label}-${label}-barcode`,
              true
            );
          });
        }
      } else {
        if (index == 0) {
          this.children.attributeOption[index2].code = label;
          this.children.attributeOption[index2].label = label;
          this.children.attributeOption[
            index2
          ].attribute.attributeOption.forEach((attribute2) => {
            attribute2.attribute.attributeOption.forEach((attribute3) => {
              this.onSetProduct(
                attribute3,
                label,
                `${this.translationList[0].name}, ${this.children.attributeOption[index2].label}, ${attribute2.label}, ${attribute3.label}`,
                `${this.sku}-${this.children.attributeOption[index2].label}-${attribute2.label}-${attribute3.label}`,
                `${this.sku}-${this.children.attributeOption[index2].label}-${attribute2.label}-${attribute3.label}-barcode`,
                false
              );
            });
          });
        } else if (index == 1) {
          this.children.attributeOption.forEach((attribute1) => {
            attribute1.attribute.attributeOption[index2].code = label;
            attribute1.attribute.attributeOption[index2].label = label;
            attribute1.attribute.attributeOption[
              index2
            ].attribute.attributeOption.forEach((attribute3) => {
              this.onSetProduct(
                attribute3,
                label,
                `${this.translationList[0].name}, ${attribute1.label}, ${attribute1.attribute.attributeOption[index2].label}, ${attribute3.label}`,
                `${this.sku}-${attribute1.label}-${attribute1.attribute.attributeOption[index2].label}-${attribute3.label}`,
                `${this.sku}-${attribute1.label}-${attribute1.attribute.attributeOption[index2].label}-${attribute3.label}-barcode`,
                false
              );
            });
          });
        } else if (index == 2) {
          this.children.attributeOption.forEach((attribute1) => {
            attribute1.attribute.attributeOption.forEach((attribute2) => {
              this.onSetProduct(
                attribute2.attribute.attributeOption[index2],
                label,
                `${this.translationList[0].name}, ${attribute1.label}, ${attribute2.label}, ${label}`,
                `${this.sku}-${attribute1.label}-${attribute2.label}-${label}`,
                `${this.sku}-${attribute1.label}-${attribute2.label}-${label}-barcode`,
                true
              );
            });
          });
        }
      }
      this.$emit("setEditFlag", true);
    },
    onSetProduct(attribute, label, name, sku, barcode, isSetBoth) {
      if (isSetBoth) {
        attribute.code = label;
        attribute.label = label;
      }
      attribute.product.translationList[0].name = name;
      attribute.product.translationList[1].name = name;
      attribute.product.sku = sku;
      attribute.product.barcode = barcode;
    },
    createChildrenFromOptionFor1Lv() {
      this.createChildrenLv1(
        this.children.attributeOption,
        this.list[0].option[this.list[0].option.length - 1]
      );
    },
    createChildrenFromOptionFor2Lv(index) {
      if (index == 0) {
        this.children.attributeOption.push({
          id: 0,
          code: this.list[0].option[this.list[0].option.length - 1].label,
          label: this.list[0].option[this.list[0].option.length - 1].label,
          sortOrder: 0,
          attributeMapperId: 0,
          attribute: {
            id: 0,
            code: this.list[1].label,
            label: this.list[1].label,
            sortOrder: 0,
            attributeOption: [],
          },
        });

        this.list[1].option.forEach((option2) => {
          this.createChildrenLv2(
            this.children.attributeOption[
              this.children.attributeOption.length - 1
            ].attribute.attributeOption,
            this.list[0].option[this.list[0].option.length - 1],
            option2
          );
        });
      } else if (index == 1) {
        this.children.attributeOption.forEach((attribute1, index1) => {
          this.createChildrenLv2(
            attribute1.attribute.attributeOption,
            this.list[0].option[index1],
            this.list[1].option[this.list[1].option.length - 1]
          );
        });
      }
    },
    createChildrenFromOptionFor3Lv(index) {
      if (index == 0) {
        this.children.attributeOption.push({
          id: 0,
          code: this.list[0].option[this.list[0].option.length - 1].label,
          label: this.list[0].option[this.list[0].option.length - 1].label,
          sortOrder: 0,
          attributeMapperId: 0,
          attribute: {
            id: 0,
            code: this.list[1].label,
            label: this.list[1].label,
            sortOrder: 0,
            attributeOption: [],
          },
        });

        this.list[1].option.forEach((option2) => {
          this.children.attributeOption[
            this.children.attributeOption.length - 1
          ].attribute.attributeOption.push({
            id: 0,
            code: option2.label,
            label: option2.label,
            sortOrder: 0,
            attributeMapperId: 0,
            attribute: {
              id: 0,
              code: this.list[2].label,
              label: this.list[2].label,
              sortOrder: 0,
              attributeOption: [],
            },
          });
        });

        this.firstLevel =
          this.children.attributeOption[
            this.children.attributeOption.length - 1
          ].label;

        this.list[2].option.forEach((option3) => {
          this.children.attributeOption[
            this.children.attributeOption.length - 1
          ].attribute.attributeOption.forEach((element) => {
            element.attribute.attributeOption.push({
              id: 0,
              code: option3.label,
              label: option3.label,
              sortOrder: 0,
              attributeMapperId: 0,
              attribute: null,
              product: {
                id: 0,
                rawPrice: 0.0,
                price: 0,
                advancePrice: {
                  price: 0.0,
                  priceAfterDiscount: 0.0,
                  startDate: this.advancePrice.startDate,
                  endDate: this.advancePrice.endDate,
                  enabled: false,
                },
                barcode: `${this.sku}-${this.firstLevel}-${element.label}-${option3.label}-barcode`,
                sku: `${this.sku}-${this.firstLevel}-${element.label}-${option3.label}`,
                weight: 0,
                image: [],
                translationList: [
                  {
                    languageId: 1,
                    name: `${this.translationList[0].name},${this.firstLevel}, ${element.label}, ${option3.label}`,
                  },
                  {
                    languageId: 2,
                    name: `${this.translationList[0].name},${this.firstLevel}, ${element.label},  ${option3.label}`,
                  },
                ],
              },
            });
          });
        });
      } else if (index == 1) {
        this.children.attributeOption.forEach((attribute1) => {
          if (
            attribute1.attribute.attributeOption.length <
            this.list[1].option.length
          ) {
            attribute1.attribute.attributeOption.push({
              id: 0,
              code: this.list[1].option[this.list[1].option.length - 1].label,
              label: this.list[1].option[this.list[1].option.length - 1].label,
              sortOrder: 0,
              attributeMapperId: 0,
              attribute: {
                id: 0,
                code: this.list[2].label,
                label: this.list[2].label,
                sortOrder: 0,
                attributeOption: [],
              },
            });

            let secondLevel =
              attribute1.attribute.attributeOption[
                attribute1.attribute.attributeOption.length - 1
              ].label;

            this.list[2].option.forEach((option3) => {
              attribute1.attribute.attributeOption[
                attribute1.attribute.attributeOption.length - 1
              ].attribute.attributeOption.push({
                id: 0,
                code: option3.label,
                label: option3.label,
                sortOrder: 0,
                attributeMapperId: 0,
                attribute: null,
                product: {
                  id: 0,
                  rawPrice: 0.0,
                  price: 0,
                  advancePrice: {
                    price: 0.0,
                    priceAfterDiscount: 0.0,
                    startDate: this.advancePrice.startDate,
                    endDate: this.advancePrice.endDate,
                    enabled: false,
                  },
                  barcode: `${this.sku}-${attribute1.label}-${secondLevel}-${option3.label}-barcode`,
                  sku: `${this.sku}-${attribute1.label}-${secondLevel}-${option3.label}`,
                  weight: 0,
                  image: [],
                  translationList: [
                    {
                      languageId: 1,
                      name: `${this.translationList[0].name},${attribute1.label}, ${secondLevel}, ${option3.label}`,
                    },
                    {
                      languageId: 2,
                      name: `${this.translationList[0].name},${attribute1.label}, ${secondLevel},  ${option3.label}`,
                    },
                  ],
                },
              });
            });
          }
        });
      } else if (index == 2) {
        this.createChildrenLv3(this.children.attributeOption);
      }
    },
    createChildrenLv1(children, option1) {
      children.push({
        id: 0,
        code: option1.label,
        label: option1.label,
        sortOrder: 0,
        attributeMapperId: 0,
        attribute: null,
        isOutOfStock: true,
        product: {
          id: 0,
          rawPrice: 0.0,
          price: 0,
          advancePrice: {
            price: 0.0,
            priceAfterDiscount: 0.0,
            startDate: this.advancePrice.startDate,
            endDate: this.advancePrice.endDate,
            enabled: false,
          },
          barcode: `${this.sku}-${option1.label}-barcode`,
          sku: `${this.sku}-${option1.label}`,
          weight: 0,
          image: [],
          translationList: [
            {
              languageId: 1,
              name: `${this.translationList[0].name}, ${option1.label}`,
            },
            {
              languageId: 2,
              name: `${this.translationList[0].name}, ${option1.label}`,
            },
          ],
        },
      });
    },
    createChildrenLv2(children, option1, option2, isCreate, parent) {
      var attributeOption = {
        id: 0,
        code: option2.label,
        label: option2.label,
        sortOrder: 0,
        attributeMapperId: 0,
        attribute: null,
        product: {
          id: 0,
          rawPrice: 0.0,
          price: 0,
          advancePrice: {
            price: 0.0,
            priceAfterDiscount: 0.0,
            startDate: this.advancePrice.startDate,
            endDate: this.advancePrice.endDate,
            enabled: false,
          },
          barcode: `${this.sku}-${option1.label}-${option2.label}-barcode`,
          sku: `${this.sku}-${option1.label}-${option2.label}`,
          weight: 0,
          image: [],
          translationList: [
            {
              languageId: 1,
              name: `${this.translationList[0].name}, ${option1.label}, ${option2.label}`,
            },
            {
              languageId: 2,
              name: `${this.translationList[0].name}, ${option1.label},  ${option2.label}`,
            },
          ],
        },
      };
      if (isCreate) {
        parent.push({
          id: 0,
          code: option1.label,
          label: option1.label,
          sortOrder: 0,
          attributeMapperId: 0,
          product: null,
          isOutOfStock: true,
          attribute: {
            id: 0,
            code: this.list[1].label,
            label: this.list[1].label,
            sortOrder: 0,
            attributeOption: [attributeOption],
          },
        });
      } else {
        children.push(attributeOption);
      }
    },
    createChildrenLv2AfterDelete(option1, option2) {
      this.list[0].option.forEach((option1) => {
        this.children.attributeOption.push({
          id: 0,
          code: option1.label,
          label: option1.label,
          sortOrder: 0,
          attributeMapperId: 0,
          attribute: {
            id: 0,
            code: this.list[1].label,
            label: this.list[1].label,
            sortOrder: 0,
            attributeOption: [],
          },
        });
      });
      this.list[1].option.forEach((option2) => {
        this.children.attributeOption.forEach((attribute1) => {
          this.createChildrenLv2(
            attribute1.attribute.attributeOption,
            attribute1,
            option2
          );
        });
      });
    },
    createChildrenLv3(children, option1, isCreate) {
      let option2 = this.list[1].option[this.list[1].option.length - 1];
      let option3 = this.list[2].option[this.list[2].option.length - 1];
      if (isCreate) {
        children.push({
          id: 0,
          code: option1.label,
          label: option1.label,
          sortOrder: 0,
          attributeMapperId: 0,
          product: null,
          isOutOfStock: true,
          attribute: {
            id: 0,
            code: this.list[1].label,
            label: this.list[1].label,
            sortOrder: 0,
            attributeOption: [],
          },
        });

        this.list[1].option.forEach((option2) => {
          children.forEach((attribute) => {
            if (
              attribute.attribute.attributeOption.length <
              this.list[1].option.length
            ) {
              attribute.attribute.attributeOption.push({
                id: 0,
                code: option2.label,
                label: option2.label,
                sortOrder: 0,
                attributeMapperId: 0,
                product: null,
                isOutOfStock: true,
                attribute: {
                  id: 0,
                  code: this.list[2].label,
                  label: this.list[2].label,
                  sortOrder: 0,
                  attributeOption: [],
                },
              });
            }
          });
        });
      }

      children.forEach((attribute1) => {
        attribute1.attribute.attributeOption.forEach((attribute2) => {
          if (
            attribute2.attribute.attributeOption.length <
            this.list[2].option.length
          ) {
            attribute2.attribute.attributeOption.push({
              id: 0,
              code: option3.label,
              label: option3.label,
              sortOrder: 0,
              attributeMapperId: 0,
              attribute: null,
              product: {
                id: 0,
                rawPrice: 0.0,
                price: 0,
                advancePrice: {
                  price: 0.0,
                  priceAfterDiscount: 0.0,
                  startDate: this.advancePrice.startDate,
                  endDate: this.advancePrice.endDate,
                  enabled: false,
                },
                barcode: `${this.sku}-${attribute1.label}-${attribute2.label}-${option3.label}-barcode`,
                sku: `${this.sku}-${attribute1.label}-${attribute2.label}-${option3.label}`,
                weight: 0,
                image: [],
                translationList: [
                  {
                    languageId: 1,
                    name: `${this.translationList[0].name}, ,${attribute1.label},${attribute2.label},${option3.label}`,
                  },
                  {
                    languageId: 2,
                    name: `${this.translationList[0].name}, ,${attribute1.label},${attribute2.label},${option3.label}`,
                  },
                ],
              },
            });
          }
        });
      });
    },
    createChildrenFromOption(index) {
      if (this.list.length == 1) {
        this.createChildrenFromOptionFor1Lv();
      } else if (this.list.length == 2) {
        this.createChildrenFromOptionFor2Lv(index);
      } else {
        this.createChildrenFromOptionFor3Lv(index);
      }
      this.$emit("setEditFlag", true);
    },
    createOptionsChoice(index) {
      this.list[index].option.push({
        id: 0,
        code: "",
        label: "",
        sortOrder: 1,
      });
      this.attributeOptionTemp = this.children.attributeOption;
      this.createChildrenFromOption(index);
    },
    createOptions: async function () {
      this.list.push({
        id: 0,
        code: "",
        label: "",
        sortOrder: 0,
        option: [
          {
            id: 0,
            code: "",
            label: "",
            sortOrder: 1,
          },
        ],
      });
      await this.clearChildren();
    },
    createChildren() {
      this.list[0].option.forEach((option1, index) => {
        if (this.list.length == 1) {
          this.createChildrenLv1(this.children.attributeOption, option1);
        } else if (this.list.length == 2) {
          this.list[1].option.forEach((option2) => {
            this.createChildrenLv2(
              this.children.attributeOption,
              option1,
              option2,
              true,
              this.children.attributeOption
            );
          });
        } else if (this.list.length == 3) {
          this.createChildrenLv3(this.children.attributeOption, option1, true);
        }
      });

      //

      this.$emit("setProductChildren", this.children);
    },
    clearChildren: async function () {
      this.children = {
        id: 0,
        code: this.list[0].code,
        label: this.list[0].label,
        sortOrder: 0,
        attributeOption: [],
      };

      await this.$emit("setProductChildren", this.children);
      await this.createChildren();
    },
  },
  created() {
    this.children = this.childrenObject;
  },
};
</script>

<style scoped>
.create-ops-box {
  color: #1085ff;
  border: 1px solid #1085ff;
  width: 300px;
  text-align: center;
  padding: 5px;
  font-weight: bold;
  border-style: dashed;
  background: #fff;
}

.ops-box {
  background: #f1f1f1;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
.delete-ops-icon {
  position: absolute;
  right: 20px;
  z-index: 1;
}

.input-ops {
  width: 75%;
}

.input-custom.error .create-ops-box {
  border-color: red !important;
}

@media (max-width: 600px) {
  .input-ops,
  .create-ops-box {
    width: 100%;
  }
}
</style>
